import { combineReducers } from 'redux';
import editorsReducer from "./editors";
import selectorgridReducer from "./SelectorGrids";
import selectorimageReducer from "./SelectorImages";
import boxReducer from "./Boxes";
import appReducer from "./app";
import { connectRouter } from "connected-react-router";

const rootReducer = (history) => combineReducers({
    router: connectRouter(history),
	app: appReducer,
	selectorgrids: selectorgridReducer,
    selectorimages: selectorimageReducer,
	boxes: boxReducer,
	editors: editorsReducer
});
export default rootReducer;